import { useState } from "react";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import { ApiError, login } from "../lib/api";
import { Button, Field } from "./ui";

export function LoginScreen({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!password) return;
    setLoading(true);
    setError("");
    try {
      await login(password);
      setPassword("");
      onAuthenticated();
    } catch (requestError) {
      setError(
        requestError instanceof ApiError ? requestError.message : "登录失败，请稍后重试。"
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-card">
        <div className="login-mark">T</div>
        <p className="eyebrow">态格 · 私人工作台</p>
        <h1>把关键的事，放在能看见的地方</h1>
        <p className="login-lead">这是单用户私人空间。登录后，电脑与手机共用一份加密传输的云端数据。</p>
        <form onSubmit={(event) => void submit(event)}>
          <Field label="访问口令" required error={error}>
            <div className="password-field">
              <LockKeyhole size={18} />
              <input
                type="password"
                autoComplete="current-password"
                autoFocus
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="输入私人访问口令"
              />
            </div>
          </Field>
          <Button type="submit" variant="primary" className="login-button" disabled={loading || !password}>
            {loading ? "正在验证…" : "进入工作台"}
          </Button>
        </form>
        <div className="login-security">
          <ShieldCheck size={17} />
          <span>口令只用于验证，不会保存在浏览器中。</span>
        </div>
      </section>
    </main>
  );
}
